import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const TossPayment = () => {
  return <CommonProcess />;
};

export default TossPayment;
